import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/Careers.css';
import { FaEnvelope, FaChevronRight } from 'react-icons/fa';

const Careers = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    designation: '',
    phone: '',
    resume: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, designation, phone, resume, message } = formData;

    // Email recipient
    const recipientEmail = 'sales@fu-tekautomation.co.in';

    // Subject for the email
    const subject = encodeURIComponent('Career Enquiry from Website');

    // Body of the email
    const body = encodeURIComponent(
      `New Career Enquiry:\n\n` +
      `Name: ${name}\n` +
      `Email: ${email}\n` +
      `Phone: ${phone}\n` +
      `Designation: ${designation}\n` +
      `Resume: ${resume}\n` +
      `Message: ${message}`
    );

    // Construct the mailto URL
    const mailtoURL = `mailto:${recipientEmail}?subject=${subject}&body=${body}`;

    // Open the default email client
    window.open(mailtoURL, '_blank');
  };

  return (
    <div className="Careers">
      <Header />

      {/* Hero Banner Section */}
      <section className="hero-banner4">
        <div className="hero-content">
          <h1>Join Our Dynamic Team</h1>
          <div className="breadcrumb">
            <span><a href="/" >Home</a></span> <FaChevronRight /> <span>Careers</span>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-layout">
        <div className="contact-main">
          <h2>Shape the Future with Us</h2>
          <p>
            At FU-TEK AUTOMATION, we believe in fostering innovation and empowering our team. We're looking for passionate individuals who are ready to make a significant impact and grow with us.
          </p>
          <p>
            Explore our open positions and discover how your skills can contribute to groundbreaking projects in automation and technology. We value diversity, collaboration, and continuous learning.
          </p>
          <div className="contact-info">
            <FaEnvelope className="contact-icon" />
            <div>
              <a href="mailto:sales@fu-tekautomation.co.in" className="contact-email-link">
                sales@fu-tekautomation.co.in
              </a>
              <p>We typically reply within 24 hours.</p>
            </div>
          </div>
        </div>

        <div className="contact-sidebar">
          <form className="contact-form" onSubmit={handleSubmit}>
            <h3>Apply Now</h3>
            <div className="form-row"> {/* New row for two inputs */}
                <div className="form-group">
                    <label htmlFor="name">Full Name</label>
                    <input type="text" id="name" name="name" placeholder="Name" required onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label htmlFor="email">Email Address</label>
                    <input type="email" id="email" name="email" placeholder="Email" required onChange={handleChange} />
                </div>
            </div>
            <div className="form-row"> {/* New row for two inputs */}
                <div className="form-group">
                    <label htmlFor="designation">Designation</label>
                    <input type="text" id="designation" name="designation" placeholder="e.g., Software Engineer" required onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label htmlFor="phone">Phone</label>
                    <input type="tel" id="phone" name="phone" placeholder="Phone Number" required onChange={handleChange} />
                </div>
            </div>
                        <div className="form-row"> {/* New row for two inputs */}
                          </div>
            <div className="form-group">
                <label htmlFor="resume">Resume URL</label>
                <input type="url" id="resume" name="resume" placeholder="Link to your online resume (e.g., Google Drive, LinkedIn)" required onChange={handleChange} />
            </div>
            <div className="form-group">
                <label htmlFor="message">Message (Optional)</label>
                <textarea id="message" name="message" placeholder="Tell us about yourself and why you're a good fit..." rows="6" onChange={handleChange}></textarea>
            </div>
            <button type="submit" className="submit-button">Submit Application</button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Careers;